// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2erKn","catchphrase":"_3Ljdr","quoteIcon":"_3-hYt","text":"_2p0tz","afterText":"_38PUU"};